import IService from '../IService';

export default IService.extend({
  _getUrl: function () {
    return app.apiUrl('/api/v1/textStyles');
  },

  post: function (data) {
    const deferred = new $.Deferred();

    $.ajax({
      url: this._getUrl(),
      cache: false,
      type: 'POST',
      timeout: 30 * app.TIME.MINUTE,

      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),

      error: function (e) {
        deferred.reject(e);
      },

      success: function (response) {
        if (!_.isEmpty(response)) {
          deferred.resolve(response);
        } else {
          deferred.reject();
        }
      },
    });

    return deferred.promise();
  },

  put: function (styleId, data) {
    const deferred = new $.Deferred();

    $.ajax({
      url: this._getUrl() + '/' + styleId,
      cache: false,
      type: 'PUT',
      timeout: 30 * app.TIME.MINUTE,

      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),

      error: function (e) {
        deferred.reject(e);
      },

      success: function (response) {
        deferred.resolve(response);
      },
    });

    return deferred.promise();
  },

  delete: function (styleId) {
    const deferred = $.Deferred();
    this.promise = deferred.promise();
    $.ajax({
      url: this._getUrl() + '/' + styleId,
      xhrFields: { withCredentials: true },
      type: 'DELETE',
      success: function (response) {
        deferred.resolve(response);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        deferred.reject(textStatus, errorThrown);
      },
    });
    return this.promise;
  },

  get: function (programmerId) {
    const deferred = $.Deferred();
    this.promise = deferred.promise();
    $.ajax({
      url: this._getUrl(),
      type: 'GET',
      data: {
        programmerId: programmerId,
      },

      success: function (response) {
        if (_.isArray(response)) {
          // for unknown reason
          response.forEach((s) => {
            s.box.applyCheckbox = s.box.apply;
            s.box.width = s.size.width;
            s.position.applyCheckbox = s.position.apply;
          });

          deferred.resolve(response);
        } else {
          app.doctorController.report('Invalid response in textStyles.js');
          deferred.reject(response);
        }
      },

      error: function (jqXHR, textStatus, errorThrown) {
        if (textStatus === 'abort') {
          console.trace('Text style request aborted by user');
        } else {
          app.doctorController.report(
            'Server error in textStyles.js ' + textStatus
          );
          deferred.reject(textStatus, errorThrown);
        }
      },

      dataType: 'json',
    });

    return this.promise;
  },
});
